import types from './types';
import assistants from './services';

const clearCurrent = () => {
  return (dispatch) => {
    dispatch({ type: types.CLEAR_CURRENT });
  }
}

const getAll = (params) => {

  function request() { return { type: types.GETALL_REQUEST } }
  function success(payload) { return { type: types.GETALL_SUCCESS, payload } }
  function failure(error) { return { type: types.GETALL_FAILURE, error } }

  return async (dispatch, getState) => {
    console.log('ACTIONS::ASSISTANTS::getAll', params);
    dispatch(request());
    const response = await assistants.getAll(params, getState().users.auth.token)
    console.log('ACTIONS::ASSISTANTS::getAll::RESPONSE FROM SERVIVE', response);
    if (response.success) {
      dispatch(success(response.data));
    } else {
      // if (response.error && response.error.code === 'ERROR_401') {
      //   console.log('APP TOKEN NOT VALID');
      //   dispatch(oauth.removeToken());
      //   dispatch(oauth.accessToken());
      // } else {
        dispatch(failure(response.error));
      // }
    }

  };  

}

const get = (params) => {
  console.log('ACTIONS::ASSISTANTS::get', params);

  const request = (payload) => { return { type: types.GET_REQUEST, payload } };
  const success = (payload) => { return { type: types.GET_SUCCESS, payload } }
  const failure = (error) => { return { type: types.GET_FAILURE, error } }

  return async (dispatch, getState) => {
    dispatch(request(params));
    let response = await assistants.get(params, getState().users.auth.token)
    console.log('ACTIONS::ASSISTANTS::get::RESPONSE FROM SERVIVE', response);
    if (response.success) {
      dispatch(success(response.data));
    } else {
      // if (response.error && response.error.code === 'ERROR_401') {
      //   console.log('APP TOKEN NOT VALID');
      //   dispatch(oauth.removeToken());
      //   dispatch(oauth.accessToken());
      // } else {
        dispatch(failure(response.error));
      // }
    }

  };

}

const saveOrUpdate = (params) => {

  function request(payload) { return { type: types.SAVE_REQUEST, payload } }
  function success(payload) { return { type: types.SAVE_SUCCESS, payload } }
  function failure(error) { return { type: types.SAVE_FAILURE, error } }

  return async (dispatch, getState) => {
    console.log('ACTIONS::ASSISTANTS::saveOrUpdate', params);
    dispatch(request(params));

    let response;
    if (params.id) {  // editing a existing record
      response = await assistants.update(params, getState().users.auth.token)
    } else {
      response = await assistants.save(params, getState().users.auth.token)
    }
    console.log('ACTIONS::ASSISTANTS::saveOrUpdate::RESPONSE FROM SERVIVE', response);
    if (response.success) {
      dispatch(success(response.data));
    } else {
      // if (response.error && response.error.code === 'ERROR_401') {
      //   console.log('APP TOKEN NOT VALID');
      //   dispatch(oauth.removeToken());
      //   dispatch(oauth.accessToken());
      // } else {
        dispatch(failure(response.error));
      // }
    }
  };

}

const del = (params) => {
  console.log('ACTIONS::ASSISTANTS::del', params);
 
  function request(id) { return { type: types.DELETE_REQUEST, id } }
  function success(id) { return { type: types.DELETE_SUCCESS, id } }
  function failure(error) { return { type: types.DELETE_FAILURE, error } }

  return async (dispatch, getState) => {
    dispatch(request(params.id));
    let response = await assistants.del(params, getState().users.auth.token)
    console.log('ACTIONS::ASSISTANTS::del::RESPONSE FROM SERVIVE', response);
    if (response.success) {
      dispatch(success(params.id));
    } else {
      // if (response.error && response.error.code === 'ERROR_401') {
      //   console.log('APP TOKEN NOT VALID');
      //   dispatch(oauth.removeToken());
      //   dispatch(oauth.accessToken());
      // } else {
        dispatch(failure(response.error));
      // }
    }
  };

}

export default {
  clearCurrent,
  get,
  getAll,
  saveOrUpdate,
  del,
};